import type { Href } from "expo-router";

/** The Backfill page's segment, which the landing page offers only behind its flag. */
export const BACKFILL_SUBPATH = "backfill";

/** The subtree every Patriot tools page lives under, below the tenant. */
export const PATRIOT_TOOLS_SEGMENT = "patriot-tools";

export function patriotToolsHref(tenantId: string, subpath = "", query: Record<string, string | undefined> = {}): Href {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(query)) {
    if (value !== undefined && value !== "") params.set(key, value);
  }
  const search = params.toString();
  const path = `/tenants/${tenantId}/${PATRIOT_TOOLS_SEGMENT}${subpath ? `/${subpath}` : ""}`;
  // Typed routes cannot see a path assembled at runtime.
  return (search ? `${path}?${search}` : path) as Href;
}

export interface PatriotTool {
  readonly subpath: string;
  readonly title: string;
  readonly description: string;
}

export interface PatriotToolSection {
  readonly title: string;
  readonly tools: readonly PatriotTool[];
}

/** The pages listed on the Patriot tools landing page, by section. Add a page here to list it. */
export const PATRIOT_TOOL_SECTIONS: readonly PatriotToolSection[] = [
  {
    title: "Query",
    tools: [
      {
        subpath: "tenant-activations",
        title: "Tenant activations",
        description: "Patriot activations for this tenant",
      },
      {
        subpath: "tenant-signals",
        title: "Tenant signals",
        description: "Patriot signals for this tenant",
      },
      {
        subpath: "fleet-activations",
        title: "Fleet activations",
        description: "Patriot activations across the whole fleet",
      },
    ],
  },
  {
    title: "Commands",
    tools: [
      {
        subpath: "connection-check",
        title: "Connection check",
        description: "Check that a3s can reach Patriot and read its data",
      },
      {
        subpath: BACKFILL_SUBPATH,
        title: "Backfill",
        description: "Copy Patriot records into a3s over a range of time",
      },
    ],
  },
];
